// src/lib/posthog/translation.ts
// Reads whether Chrome/Edge's machine translation marked the page, without
// touching anything but the value it is handed: pure, and it never throws.
// `true` means "a translation marker was present", not "the page was
// translated".

const TRANSLATED_CLASSES = ["translated-ltr", "translated-rtl"];

/** A `DOMTokenList`-shaped value: only the method this module calls. */
export interface ClassListLike {
  contains(token: string): boolean;
}

/**
 * `true` if `classList` contains `translated-ltr` or `translated-rtl`,
 * `false` if it was read and contains neither, `null` if `classList` is
 * null/undefined or reading it throws.
 */
export function translatedFromClassList(classList: ClassListLike | null | undefined): boolean | null {
  if (!classList) return null;
  try {
    return TRANSLATED_CLASSES.some((token) => classList.contains(token));
  } catch {
    return null;
  }
}

/**
 * `null` when `doc` is undefined or has no `documentElement`; otherwise
 * delegates to `translatedFromClassList`. Defaults to the global `document`,
 * evaluated at call time so it is safe to import on the server.
 */
export function readTranslated(
  doc: Document | undefined = typeof document === "undefined" ? undefined : document,
): boolean | null {
  try {
    if (!doc || !doc.documentElement) return null;
    return translatedFromClassList(doc.documentElement.classList);
  } catch {
    return null;
  }
}
